<script>
import View from 'ol/View'

export default {
  name: 'ol-view',

  inject: ['getMap'],

  props: {
    // 投影坐标系
    projection: {
      type: String,
      default: 'EPSG:4326',
      validator: value => ['EPSG:4326', 'EPSG:3857'].indexOf(value) !== -1
    },

    // 中心点
    center: {
      type: Array,
      default: ()=>[]
    },

    // 缩放层级
    zoom: {
      type: Number,
      default: 10
    },

    // 最小缩放层级
    minZoom: {
      type: Number,
      default: 1
    },

    // 最大缩放层级
    maxZoom: {
      type: Number,
      default: 18
    },

    // 填充（css 像素）
    padding: {
      type: Array,
      default: () => [0, 0, 0, 0]
    },

    // 约束范围，在地图上看不到该范围之外的任何内容
    extent: {
      type: Array,
      default:()=>[]
    }
  },

  watch: {
    // center (newVal) {
    //   // this.view.setCenter(newVal)
    // },

    extent (newVal) {
      this.view.fit(newVal,{ padding: [80, 20, 80, 20]})
    }
  },

  data () {
    return {
      view: null,
      defaultZoom: this.zoom
    }
  },

  created () {
    this.view = new View({
      projection: this.projection,
      // center: this.center,
      zoom: this.zoom,  
      minZoom: this.minZoom,
      maxZoom: this.maxZoom,
      padding: this.padding
    })
    this.view.fit(this.extent,{ padding: [80, 20, 80, 20]})
    this.view.on('change', this.changeHandle)

    this.getMap(map => {
      map.setView(this.view)
    })
  },

  methods: {
    // 视图改变事件处理函数
    changeHandle (e) {
      this.$emit('update:zoom', e.target.getZoom())
    },

    // 复位
    reset () {
      this.view.setRotation(0)
      // this.view.setCenter(this.center)
      this.view.fit(this.extent,{ padding: [80, 20, 80, 20] })
      // this.view.setZoom(this.defaultZoom)
      // this.$emit('update:zoom', this.defaultZoom)
    },

    // 缩小
    zoomOut () {
      const zoom = this.view.getZoom() - 1
      this.view.setZoom(zoom)
      this.$emit('update:zoom', zoom)
    },

    // 放大
    zoomIn () {
      const zoom = this.view.getZoom() + 1
      this.view.setZoom(zoom)
      this.$emit('update:zoom', zoom)
    }
  },

  beforeDestroy () {
    this.view.un('change', this.changeHandle)
    this.view = null
  },

  render () {
    return null
  }
}
</script>
